import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { translate as t } from 'hooks/useTranslations';
import { SolutionWithActive } from '../_types';
import SolutionTabCard from '../components/SolutionTabCard';

type ManageSolutionsListProps = {
  currentSolutions: SolutionWithActive[];
  selectedSolution: SolutionWithActive | null;
  onSolutionSelect: (solution: SolutionWithActive) => void;
  currentPage: number;
  totalPages: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
};

const ManageSolutionsList: React.FC<ManageSolutionsListProps> = ({
  currentSolutions,
  selectedSolution,
  onSolutionSelect,
  currentPage,
  totalPages,
  onPreviousPage,
  onNextPage,
}) => {
  // Calculate solutions per page based on current solutions length
  const solutionsPerPage = currentSolutions.length;

  return (
    <>
      {/* Solution Cards - Grid Layout */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${solutionsPerPage}, 1fr)`,
          gap: 3,
          mb: 2,
        }}
      >
        {currentSolutions.map((solution) => (
          <SolutionTabCard
            key={solution.id}
            solution={solution}
            selected={selectedSolution?.id === solution.id}
            onSelect={onSolutionSelect}
          />
        ))}
      </Box>

      {/* Pagination */}
      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
          <IconButton
            onClick={onPreviousPage}
            disabled={currentPage === 0}
            size='small'
          >
            <ChevronLeft />
          </IconButton>

          <Typography
            variant='body2'
            sx={{ mx: 2 }}
          >
            {currentPage + 1} of {totalPages}
          </Typography>

          <IconButton
            onClick={onNextPage}
            disabled={currentPage === totalPages - 1}
            size='small'
          >
            <ChevronRight />
          </IconButton>
        </Box>
      )}
    </>
  );
};

export default ManageSolutionsList;
